<template>
  <b-card no-body>
    <b-card-header class="p-0 mb-1" style="height: initial">
      <h5 class="my-0 text-center">
        <b-button
          variant="link"
          class="py-2 px-3"
          :class="visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          :aria-controls="'collapse-' + idCollapsable"
          @click="visible = !visible"
        >
          {{ tituloColapsable }}
          <span
            class="col-1 float-right text-md-right px-0 d-none d-md-inline-block when-close"
          >
            <FontAwesomeIcon icon="plus" class="h6" />
          </span>
          <span
            class="col-1 float-right text-md-right px-0 d-none d-md-inline-block when-open"
          >
            <FontAwesomeIcon icon="minus" class="h6" />
          </span>
        </b-button>
      </h5>
    </b-card-header>
    <b-collapse :id="'collapse-' + idCollapsable" v-model="visible">
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPlus, faMinus);
export default {
  name: "ContenedorCollapsable",
  props: {
    idCollapsable: { type: String },
    tituloColapsable: { type: String }
  },
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.modoMovil();
  },
  methods: {
    modoMovil() {
      return screen.width > 1024;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/comparadorITP/ContenedorCollapsable.vue